import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierPlanQuickInfo extends Layout {
    panelQuickInfo: Panel;
    sourceCarrierPlanLookup: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
